import { useCommunityUserUIStore } from '@communities/community-user-layer/stores/community-user.ui-store'

import { clearAllPendingCheckoutState } from '../composables/pending-checkout.state'

/**
 * Clear Pinia fallbacks that can mask fresh user-group query data after leaving a group.
 * Also drops abandoned checkout pending (change-plan or join-offer) so a later rejoin
 * cannot PUT a stale plan.
 */
export function resetCommunitiesMembershipUiAfterLeaveGroup(): void {
  clearAllPendingCheckoutState()
  try {
    useCommunityUserUIStore().setCurrentCommunityUser(null)
  } catch {
    // Pinia may be unavailable in some test harnesses
  }
}
